<template>
  <span v-if="!edit" class="text-sm">
    {{ value || 'Sem resposta' }}
  </span>

  <SelectAnswer v-else v-bind="$attrs" no-label :question="original" />
</template>

<script>

import SelectAnswer from '#views/questionnaire/answers/SelectAnswer';

export default {
  name: "SelectDetail",
  inheritAttrs: false,
  components: {
    SelectAnswer
  },
  props: {
    original: {
      type: Object,
      required: true,
    },
    value: {
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  mounted(){
    this.$emit("update:modelValue", this.value);
  }
};
</script>
